<script lang="ts">
  import { page } from '$app/stores'
  import { Button, Form, type Language } from '@bond/components'
  import { META_TITLE_SUFFIX } from '$lib/constants/meta'
  import { STRINGS } from '$lib/constants/strings'
  import { utils } from '$lib/utils'

  $: lang = ($page.params.lang || 'en') as Language
  $: localeRoute = utils.getRoute(lang)
</script>

<svelte:head>
  {#if $page.status === 401}
    <title>{STRINGS[lang].ERROR_ACCESS_DENIED}{META_TITLE_SUFFIX}</title>
  {:else if $page.status === 404}
    <title>{STRINGS[lang].ERROR_PAGE_NOT_FOUND}{META_TITLE_SUFFIX}</title>
  {:else}
    <title>{STRINGS[lang].ERROR_SOMETHING_WENT_WRONG}{META_TITLE_SUFFIX}</title>
  {/if}
</svelte:head>
<div class="container">
  {#if $page.status === 401}
    <div class="container">
      <h1>401 - {STRINGS[lang].ERROR_ACCESS_DENIED}</h1>
      <Form action="/auth/signout">
        <Button
          variant="outlined"
          rounded
          appendIcon="ph-arrow-clockwise"
          type="submit"
        >
          {STRINGS[lang].ERROR_TRY_ANOTHER_ACCOUNT}
        </Button>
      </Form>
    </div>
  {:else if $page.status === 404}
    <h1>404</h1>
    <p>{STRINGS[lang].ERROR_PAGE_NOT_FOUND}</p>
    <Button rounded prependIcon="ph-house-fill" href={localeRoute('/')}>
      {STRINGS[lang].ERROR_BACK_TO_HOME}
    </Button>
  {:else}
    <h1>{STRINGS[lang].ERROR_SOMETHING_WENT_WRONG}</h1>
  {/if}
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 4em;
    width: 100%;

    h1 {
      text-align: center;
    }
  }
</style>
